import React from "react";
import styles from "./Footer.module.scss";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { LightLogo, SocialMedia } from "../../../components/SvgIcons";

const Footer: React.FC = () => {
  return (
    <footer>
      <div className={styles.footer}>
        <Container className={styles.footerContent}>
          <div className={styles.contact}>
            <Link to="/" className={styles.Logo}>
              <LightLogo />
            </Link>
            <h3>8 (989) 299-10-10</h3>
            <h3>INFO@ROOMSELLER.RU</h3>
          </div>
          <ul className={styles.centerDiv}>
            <li>
              <a href="/#about">О НАС</a>
            </li>
            <li>
              <a href="/#marketplaces">МАРКЕТПЛЕЙСЫ</a>
            </li>
            <li>
              <a href="/#reliably">ПРЕИМУЩЕСТВА</a>
            </li>
          </ul>
          <ul className={styles.centerDiv2}>
            <li>
              <a href="/suppliers">ПОСТАВЩИКАМ</a>
            </li>
            <li>
              <a href="/terms">УСЛОВИЯ</a>
            </li>
            <li>
              <a href="/privacy">ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</a>
            </li>
          </ul>
          <ul className={styles.social}>
            <li>МЫ В СОЦСЕТЯХ</li>
            <SocialMedia />
          </ul>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
